import { FC } from "react";
import { Feature } from "ui-library";
import { feature } from "types/CMS/Unum/feature";
import { PortableText } from "@kontent-ai/rich-text-resolver/utils/react";
import useInternalExternalNavigate from "hooks/CMS/useInternalExternalNavigate/useInternalExternalNavigate";

const EmployerFeatureSection: FC<{ section: feature }> = ({ section }) => {
  const internalExternalNavigate = useInternalExternalNavigate();
  return (
    <Feature
      alignItem={section.layout}
      content={<PortableText {...section.body} />}
      src={section.asset.url}
      title={section.title}
      assetType={section.asset.type}
      buttonOneLabel={section.cta?.[0]?.label}
      buttonTwoLabel={section.cta?.[1]?.label}
      buttonThreeLabel={section.cta?.[2]?.label}
      buttonOneAction={() => {
        internalExternalNavigate(section.cta?.[0]);
      }}
      buttonTwoAction={() => {
        internalExternalNavigate(section.cta?.[1]);
      }}
      buttonThreeAction={() => {
        internalExternalNavigate(section.cta?.[2]);
      }}
    />
  );
};

export default EmployerFeatureSection;
